<template>
  <v-container grid-list-xl text-xs-center>
    <v-layout row wrap>
      <v-flex xs10 offset-xs1>
        <form>
          <v-text-field ref="email" placeholder=" " v-model="email" :error-messages="emailErrorMsgs" label="Email" required @input="$v.email.$touch()" @blur="$v.email.$touch()"></v-text-field>
          <v-text-field ref="password" placeholder=" " v-model="password" v-on:keyup.enter='submit' autocomplete type="password" :error-messages="passwordErrorMsgs" label="Password" required @input="$v.password.$touch()" @blur="$v.password.$touch()"></v-text-field>
          <v-btn @click="submit" :loading="loading">submit</v-btn>
          <v-btn @click="clear" :disabled="loading">clear</v-btn>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import vh, { email, password } from '@/helpers/validators'
  import { mapMutations } from 'vuex'

  export default {
    data () {
      return {
        email: '',
        password: '',
        loading: false
      }
    },
    validations: {
      email: vh.vrules(email),
      password: vh.vrules(password)
    },
    computed: {
      emailErrorMsgs () {
        if (this.$v.email.$dirty) {
          return vh.vmsg(this.$v.email, email)
        } else {
          return []
        }
      },
      passwordErrorMsgs () {
        if (this.$v.password.$dirty) {
          return vh.vmsg(this.$v.password, password)
        } else {
          return []
        }
      }
    },
    methods: {
      ...mapMutations('notification', ['notify']),
      submit () {
        this.$v.$touch()
        if (this.$v.$invalid) return
        this.login()
      },
      clear () {
        this.$v.$reset()
        this.email = ''
        this.password = ''
      },
      async login () {
        try {
          this.loading = true
          await this.$store.dispatch('auth/login', { ...this.$data })
          this.notify({message: 'You have been logged in.', show: true})
          this.loading = false
          this.$router.push('/home')
        } catch (e) {
          this.loading = false
          this.notify({message: 'You have failed to log in. Try again with other credentials.', show: true})
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Login.vue